<template>
  <div>
    <input
      id="autocompleteplace"
      ref="autocompleteplace"
      v-model="value"
      :placeholder="placeholder"
      :name="name"
      :class="inputClass"
      :type="type"
      @input="getValue"
      @click="getValue"
      @change="getValue"
      @keydown.enter="getValue"
      @select="getValue"
      @blur="getValue"
    />
  </div>
</template>

<script>
export default {
  props: {
    valueSet: {
      type: String,
      default: ""
    },
    inputClass: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    }
  },
  data: () => ({
    autocomplete: "",
    indf: "",
    value: "",
    position: null
  }),
  mounted() {
    //   if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(function(position) {
    //     var geolocation = {
    //       lat: position.coords.latitude,
    //       lng: position.coords.longitude
    //     };
    //     var circle = new google.maps.Circle(
    //         {center: geolocation, radius: position.coords.accuracy});
    //     // this.autocomplete.setBounds(circle.getBounds());
    //     console.log(geolocation)
    //   });
    // }

    var options = {
      types: ["(regions)"]
    };

    this.value = this.valueSet;
    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.autocompleteplace,
      options
    );
  },

  methods: {
    getValue() {
      let timer = this.getValue.timer;
      if (timer) {
        clearTimeout(timer);
      }
      this.getValue.timer = setTimeout(() => {
        var inputValue = document.getElementById("autocompleteplace").value;
        this.fillInAddress(inputValue);
      }, 800);
    },
    fillInAddress(inputValue) {
      var componentForm = {
        street_number: "short_name",
        route: "long_name",
        locality: "long_name",
        administrative_area_level_1: "long_name",
        country: "long_name",
        postal_code: "short_name"
      };
      var place = this.autocomplete.getPlace();
      if (place) {
        var data = {};
        for (var i = 0; i < place.address_components.length; i++) {
          var addressType = place.address_components[i].types[0];
          if (componentForm[addressType]) {
            var val = place.address_components[i][componentForm[addressType]];
            data[addressType] = val;
          }
        }
        const returnObj = {
          address: inputValue,
          location: data
        };
        console.log(returnObj);
        this.$emit("input", returnObj);
      }
    }
  }
};
</script>

<style>
</style>
